"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.greaterThanEqualToSemverMatcherContext = void 0;
var Semver_1 = require("../../utils/Semver");
function greaterThanEqualToSemverMatcherContext(ruleAttr) {
    var ruleSemver = new Semver_1.Semver(ruleAttr);
    return function greaterThanEqualToSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver_1.Semver(runtimeAttr);
        var isGreaterThanEqual = runtimeSemver.compare(ruleSemver) >= 0;
        return isGreaterThanEqual;
    };
}
exports.greaterThanEqualToSemverMatcherContext = greaterThanEqualToSemverMatcherContext;
